import * as React from 'react'


interface ParentProps {
    toggleFn: any;
    updateValidator: any;
    showValidatorForm: boolean;
    locale: string;
    chatbotsettings: any;
}

interface RatingProps {
    showPopup: boolean,
    enableUserValidator: boolean,
    conversationId: string,
    ValidateText?: string,
    OkButton?: string
}


export class UserValidator extends React.Component<ParentProps, RatingProps> {
    state: RatingProps = {
        showPopup: this.props.showValidatorForm,
        enableUserValidator: false,
        conversationId: ''
    };
    
    closePopupFn = () => {
        this.setState({
            showPopup: false,
            enableUserValidator: false,
            conversationId: ''
        })
        localStorage.setItem('enableOkButton', "true");
    }
    updateShowPopUp = (conversationid: any) => {
        localStorage.setItem('enableOkButton', "true");
        this.setState({ showPopup: true, enableUserValidator: true, conversationId: conversationid })
    }
    submitPopupFn = () => {
        localStorage.setItem('enableOkButton', "true");
        this.setState({
            showPopup: false,
            enableUserValidator: true,
        })
        this.props.updateValidator(this.state);
       
    }

    async componentDidMount() {
        // GET request using fetch with async/await
        const response = await fetch(this.props.chatbotsettings.configvaluesurl, {
            headers: {
                'ApiKey': this.props.chatbotsettings.configvaluesurlapikey,
                'Content-type': 'application/json'
            },
            method: 'GET'

        });
        if (this.state.showPopup == true) {
            localStorage.setItem('enableOkButton', "true");
        }
        const data = await response.json();
        if (this.props.locale === 'fr') {
            this.state.ValidateText = data.filter((list: any) => list.referenceKey === 'User Validator')[0].frenchMessage;
            this.state.OkButton = data.filter((list: any) => list.referenceKey === 'Okbutton')[0].frenchMessage;

        }
        else {

            this.state.ValidateText = data.filter((list: any) => list.referenceKey === 'User Validator')[0].message;
            this.state.OkButton = data.filter((list: any) => list.referenceKey === 'Okbutton')[0].message;

        }
    }
    render() {
       
        return (
            <div>

                {this.state.showPopup ?
                    <div className="popup">
                        <div className="overlay popup-overlay"></div>
                        <div className="popup-container">
                            <div className="popup-content">
                                <div className="popup-top">
                                    <a title="Close Popup" className="close-btn" onClick={this.closePopupFn}><i className="fa fa-close"></i></a>
                                    <p> {this.state.ValidateText}</p>
                                </div>
                                <div className="popupContent-container">
                                    <div className="btn-container">
                                        <button type="button"
                                            className="p-btn btn" onClick={this.submitPopupFn}>{this.state.OkButton} </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    : ''}

            </div>
        );
    }
}
export default UserValidator;
